import React from "react";
import { default as Text } from "./Text";
import { default as List } from "./List";
import { default as Icons } from "./Icons";
import { default as Image } from "./Image";
import { default as Table } from "./Table";
import { default as SingleScreenList } from "./SingleScreenList";
import { default as NumberList } from "./NumberList";
import { default as ScalingImage } from "./ScalingImage";
import ImgTextRow from "./ImgTextRow";
import StaticScreen from "./StaticScreen";
import ImageInImage from "./ImageInImage";
import NonTVImg from "./NonTVImg";
import GameOpt from "./GameOpt";
import { Player, Controls } from "@lottiefiles/react-lottie-player";

import cloudGame1 from "../../json/cloud-game-1.json"; //offline version
import cloudGame2 from "../../json/cloud-game-2.json"; //offline version

export default function Body({
  side,
  myJSON,
  emulatorStep,
  setIsSingleStepScreen,
  setSingleScreenStepLength,
  singleScreenStep,
  page,
}) {
  if (side === "left") {
    return (
      <div
        className="info-body"
        style={{
          borderLeft: myJSON.body.border_width
            ? `${myJSON.body.border_width} solid ${myJSON.body.border_color}`
            : null,
          // margin: myJSON.body.margin ? myJSON.body.margin : "0px",
          margin: myJSON.body.margin ? myJSON.body.margin : "0 0 0 0px",
          height: myJSON.body.height ? myJSON.body.height : null,
        }}
      >
        {myJSON.steps &&
        myJSON.steps[emulatorStep] &&
        myJSON.steps[emulatorStep].hide_overlay_content
          ? null
          : myJSON.body.content
          ? myJSON.body.content.map((obj, i) => {
              switch (obj.component) {
                case "text":
                  return <Text key={`body${i}`} content={obj} />;
                case "list":
                  return <List key={`body${i}`} content={obj} />;
                case "icons":
                  return <Icons page={page} key={`body${i}`} content={obj} />;
                case "game-opt":
                  return <GameOpt key={`body${i}`} content={obj} />;
                case "image":
                  return (
                    <Image
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                      page={page}
                    />
                  );
                case "image-in-image":
                  return <ImageInImage key={`body${i}`} content={obj} />;
                case "image-text-row":
                  return <ImgTextRow key={`body${i}`} content={obj} />;
                case "scaling-image":
                  return (
                    <ScalingImage
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                    />
                  );
                case "number-list":
                  return <NumberList content={obj} />;
                case "single-screen-list":
                  setIsSingleStepScreen(true);
                  setSingleScreenStepLength(obj.content.length);
                  return (
                    <SingleScreenList
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                      setIsSingleStepScreen={setIsSingleStepScreen}
                    />
                  );
                default:
                  return null;
              }
            })
          : null}
      </div>
    );
  } else {
    return (
      <div
        className="right-content"
        style={{
          margin: myJSON.content_data.right_content.margin,
          justifyContent: myJSON.content_data.right_content.justify_content
            ? myJSON.content_data.right_content.justify_content
            : "center",
          transformOrigin: myJSON.content_data.right_content.transform_origin
            ? myJSON.content_data.right_content.transform_origin
            : null,
        }}
      >
        {myJSON.content_data.right_content.content &&
          myJSON.content_data.right_content.content.map((obj, i) => {
            switch (obj.component) {
              case "text":
                return <Text key={`rightContent${i}`} content={obj} />;
              case "list":
                return <List key={`rightContent${i}`} content={obj} />;
              case "icons":
                return (
                  <Icons page={page} key={`rightContent${i}`} content={obj} />
                );
              case "image-text-row":
                return <ImgTextRow key={`body${i}`} content={obj} />;
              case "tv-sim":
                return <StaticScreen key={`rightContents${i}`} obj={obj} />;
              case "image":
                return <Image key={`rightContent${i}`} content={obj} />;
              case "image-in-image":
                return <ImageInImage key={`body${i}`} content={obj} />;
              case "scaling-image":
                return (
                  <ScalingImage
                    key={`body${i}`}
                    content={obj}
                    singleScreenStep={singleScreenStep}
                  />
                );
              case "lottie":
                return (
                  <Player
                    speed={1.7}
                    className="lottie-player"
                    autoplay
                    direction={"forwards"}
                    keepLastFrame={true}
                    // src={obj.src} // Online version
                    src={
                      obj.src === "./cloud-game-2.json"
                        ? cloudGame2
                        : cloudGame1
                    } 
                    //Local Version
                    style={{
                      transformOrigin: "top left",
                      height: "75%",
                      width: "75%",
                      position: "absolute",
                      transform: "translateY(20px)",
                    }}
                  ></Player>
                );
              case "non-tv-img":
                return <NonTVImg key={`body${i}`} content={obj} />;
              case "table":
                return <Table content={obj} />;
              case "number-list":
                return <NumberList content={obj} />;
              // case "single-screen-list":
              // 	setIsSingleStepScreen(true);
              // 	setSingleScreenStepLength(obj.content.length);
              // 	return (
              // 		<SingleScreenList
              // 			content={obj}
              // 			singleScreenStep={singleScreenStep}
              // 			setIsSingleStepScreen={setIsSingleStepScreen}
              // 		/>
              // 	);
              default:
                return null;
            }
          })}
      </div>
    );
  }
}
